import { DEFAULT_DATE_FORMAT } from 'api/models/core-types';
export const defaultFormat = (date)=>date.format(DEFAULT_DATE_FORMAT);
